import React from 'react'
import PropTypes from 'prop-types'
import { useDemographic, useMetric, useRegion } from '../app/hooks'
import SedaMenu from './SedaMenu'
import { getDemographicsForRegion } from '../app/selectors/demographics'
import { getSubjectFromMetricId } from '../app/selectors'

const SedaSubgroupSelect = ({ onSelect, ...props }) => {
  const [metric] = useMetric()
  const [region] = useRegion()
  const [demographic, setDemographic] = useDemographic()
  const demographics = getDemographicsForRegion(region)
  const subject = getSubjectFromMetricId(metric)
  const disabledDemographics = subject === "abs"
    ? demographics.filter(d => d !== "all")
    : []
  const disabledHint = `Subgroups are not available for chronic absenteeism`
  const handleClick = demId => {
    if (demographic !== demId) {
      setDemographic(demId)
      onSelect && onSelect(demId)
    }
  }

  return (
    <SedaMenu
      value={demographic}
      items={demographics}
      disabledItems={disabledDemographics}
      disabledHint={disabledHint}
      onSelect={handleClick}
      {...props}
    />
  )
}

SedaSubgroupSelect.propTypes = {
  onSelect: PropTypes.func
}

export default SedaSubgroupSelect
